import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

// Plain native <select> — Radix's popup select adds ~30KB and a11y
// requirements we don't need for the filter bars. If a later design
// calls for rich option rendering we can swap this for @radix-ui/react-select.
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
